require('./bootstrap');

require('./assets/offcanvas');
require('./assets/menu-search');
require('./assets/scroll');
require('./assets/sliter-items');
require('./assets/modais');
require('./assets/laziloader');
require('./assets/magnificPopup');